// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2if-f","list":"BalanceDue_list__2qxp5","listRow":"BalanceDue_listRow__3mYUu","total":"BalanceDue_total__sesWV"};